var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M9.5 2.96L7 3.587v9.453l2.5-.625V2.961zm1.5 0v9.454l2.5.625V3.586L11 2.96zm-5.5.626L3 2.96v9.453l2.5.625V3.586zm.932 11.142a.75.75 0 0 1-.364 0l-4-1A.75.75 0 0 1 1.5 13V2a.75.75 0 0 1 .932-.728l3.818.955 3.818-.955a.75.75 0 0 1 .364 0l4 1A.75.75 0 0 1 15 3v11a.75.75 0 0 1-.932.728l-3.818-.955-3.818.955z" })
  );
});